export default "/images/8072df4d06455c5888d8c522d0e626f5.avif";